// Reusable PDF export utility.
// Builds a clean tabular PDF from headers + rows (same shape as CSV).
//
// Usage:
//   import { exportTableToPDF } from "./utils/exportPDF";
//   exportTableToPDF({
//     title: "Stock Report",
//     headers: ["S.No.", "Item", "Qty"],
//     rows: [[1, "Rice", 50], [2, "Dal", 20]],
//     filename: "stock_report.pdf",
//     filterInfo: "From: 01-04-2026 | To: 30-04-2026",   // optional
//     orientation: "l",                                   // optional, "p" or "l", default "l"
//   });

import jsPDF from "jspdf";

export const exportTableToPDF = ({
  title = "Report",
  headers = [],
  rows = [],
  filename = "report.pdf",
  filterInfo = "",
  orientation = "l",
}) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    alert("No data to export.");
    return;
  }

  const pdf = new jsPDF(orientation, "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const marginX = 8;
  const usableWidth = pageWidth - marginX * 2;

  // Distribute column widths equally (simple, works for most reports)
  const colCount = headers.length || (rows[0] ? rows[0].length : 1);
  const colWidth = usableWidth / colCount;
  const rowHeight = 7;

  const drawHeader = () => {
    pdf.setFontSize(14);
    pdf.setFont(undefined, "bold");
    pdf.text(title, pageWidth / 2, 10, { align: "center" });
    if (filterInfo) {
      pdf.setFontSize(9);
      pdf.setFont(undefined, "normal");
      pdf.text(filterInfo, pageWidth / 2, 16, { align: "center" });
    }
  };

  const drawRow = (cells, y, isHeader = false) => {
    let x = marginX;
    pdf.setFontSize(8);
    if (isHeader) {
      pdf.setFillColor(25, 55, 135);
      pdf.setTextColor(255, 255, 255);
      pdf.setFont(undefined, "bold");
      pdf.rect(marginX, y, usableWidth, rowHeight, "F");
    } else {
      pdf.setTextColor(0, 0, 0);
      pdf.setFont(undefined, "normal");
    }
    cells.forEach((c, i) => {
      pdf.rect(x, y, colWidth, rowHeight);
      const text = c === null || c === undefined ? "" : String(c);
      pdf.text(text, x + 1.5, y + rowHeight / 2 + 1.5, {
        maxWidth: colWidth - 3,
      });
      x += colWidth;
    });
  };

  drawHeader();
  let y = filterInfo ? 22 : 16;

  if (headers.length > 0) {
    drawRow(headers, y, true);
    y += rowHeight;
  }

  rows.forEach((row) => {
    if (y + rowHeight > pageHeight - 8) {
      pdf.addPage();
      drawHeader();
      y = filterInfo ? 22 : 16;
      if (headers.length > 0) {
        drawRow(headers, y, true);
        y += rowHeight;
      }
    }
    drawRow(row, y, false);
    y += rowHeight;
  });

  pdf.save(filename);
};
